import React, { useState } from 'react'
import FileUploadForm from './FileUploadForm'
import PatientDataForm from './PatientDataForm'
import styles from './ADHDForm.module.css'

const ADHDForm = () => {
  const [activeTab, setActiveTab] = useState('patient')

  const tabs = [
    {
      id: 'patient',
      label: 'Patient Information',
      content: <PatientDataForm />,
    },
    { id: 'upload', label: 'File Upload', content: <FileUploadForm /> },
  ]

  return (
    <div className={styles.section}>
      <div className={`dashboard-cards ${styles.container}`}>
        <nav
          className={styles.tabList}
          role='tablist'
          aria-label='ADHD Form Sections'
        >
          <div className={`${styles.tabWrapper}`}>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                role='tab'
                aria-selected={activeTab === tab.id}
                aria-controls={`${tab.id}-panel`}
                id={`${tab.id}-tab`}
                tabIndex={activeTab === tab.id ? 0 : -1}
                className={`${styles.tabTrigger} ${
                  activeTab === tab.id ? styles.activeTab : ''
                }`}
                onKeyDown={(e) => {
                  if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                    e.preventDefault()
                    const currentIndex = tabs.findIndex(
                      (t) => t.id === activeTab
                    )
                    const newIndex =
                      e.key === 'ArrowLeft'
                        ? (currentIndex - 1 + tabs.length) % tabs.length
                        : (currentIndex + 1) % tabs.length
                    setActiveTab(tabs[newIndex].id)
                  }
                }}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </nav>

        {tabs.map((tab) => (
          <div
            key={tab.id}
            role='tabpanel'
            id={`${tab.id}-panel`}
            aria-labelledby={`${tab.id}-tab`}
            hidden={activeTab !== tab.id}
            className={styles.tabContent}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ADHDForm
